import DoorLockSettings from 'localization/base/pages/DoorLockSettings';

const doorLockSettings: DoorLockSettings = {
  header: 'Door locking',
  mainDoors: 'Main door'
};

export default doorLockSettings;
